import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SplashScreenComponent } from './splash-screen/splash-screen.component';
import { ShellComponent } from './shell/shell.component';
import { RecipeListComponent } from './recipe-list/recipe-list.component';
import { RecipeDetailsComponent } from './recipe-details/recipe-details.component';
import { UnderConstructionComponent } from './under-construction/under-construction.component';
import { SlideMenuComponent } from './slide-menu/slide-menu.component';
import { KeyColorFontDirective } from './directives/key-color-font.directive';
import { KeyColorBackgroundDirective } from './directives/key-color-background.directive';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { FootPortalHttpInterceptor } from './services/food-portal.interceptor';
import { PromoteComponent } from './promote/promote.component';
import { AllergenMenuComponent } from './allergens-menu/allergen-menu.component';
import { Co2eBadgeComponent } from './recipe-details/co2e-badge/co2e-badge.component';
import { Co2eInfoComponent } from './co2e-info/co2e-info.component';
import { RecipeCardComponent } from './recipe-list/recipe-card/recipe-card.component';

@NgModule({
  declarations: [
    AppComponent,
    SplashScreenComponent,
    UnderConstructionComponent,
    ShellComponent,
    RecipeListComponent,
    RecipeDetailsComponent,
    SlideMenuComponent,
    AllergenMenuComponent,
    KeyColorFontDirective,
    KeyColorBackgroundDirective,
    DisclaimerComponent,
    PromoteComponent,
    Co2eBadgeComponent,
    Co2eInfoComponent,
    RecipeCardComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: FootPortalHttpInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
